import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'
import { alignmentToJustify } from '../../enums/alignmentToJustify'
import { TableAlignmentProps } from '../../types/alignment'
import { TableSortableProps } from '../../types/sortable'
import { getDynamicSizeColumnStyles } from '../../utils/getDynamicSizeColumnStyles'
import { getFixedSizeColumnStyles } from '../../utils/getFixedSizeColumnStyles'

interface TableHeaderItemWrapperProps extends TableAlignmentProps, Partial<TableSortableProps> {
  fixedSize?: boolean
  sorted?: boolean
}

export const TableFooterItemWrapper = styled.div<TableHeaderItemWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: ${({ alignment }) => alignmentToJustify[alignment]};
  margin-right: ${Spacing.S24};
  ${({ fixedSize }) => (fixedSize ? getFixedSizeColumnStyles() : getDynamicSizeColumnStyles())};

  &:last-of-type {
    margin-right: 0;
  }
`
